import AR_RESOURCE from "./ar.json";
import EN_RESOURCE from "./en.json";

export const translationResources = {
  ar: AR_RESOURCE,
  en: EN_RESOURCE,
} as const;
export const getTranslation = (lang: "en" | "ar") => {
  const trans = translationResources[lang];
  if (!trans) {
    throw new Error("trans error");
  } else {
    return trans;
  }
};
